export default __webpack_public_path__ + "static/media/english-to-latvian-screenshot-06.7f77648c.png";